import { render, staticRenderFns } from "./viewACORD.vue?vue&type=template&id=506b9acb&scoped=true"
import script from "./viewACORD.vue?vue&type=script&lang=js"
export * from "./viewACORD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b9acb",
  null
  
)

export default component.exports